import {UserRole} from "@/shared/enums/UserRolesEnums";
import PrivateCoaching from "@/views/App/Analytics/Unemployed/Overview/PrivateCoaching/List.vue";
import GroupCoaching from "@/views/App/Analytics/Unemployed/Overview/GroupCoaching/List.vue";
import SocioTherapyCoaching from "@/views/App/Analytics/Unemployed/Overview/SocioTherapyCoaching/List.vue";
import AssistedLivingCoaching from "@/views/App/Analytics/Unemployed/Overview/AssistedLivingCoaching/List.vue";
import OccupationalTherapyCoaching
    from "@/views/App/Analytics/Unemployed/Overview/OccupationalTherapyCoaching/List.vue";
import JobCoaching from "@/views/App/Analytics/Unemployed/Overview/JobCoaching/List.vue";
import CaseManagementCoaching from "@/views/App/Analytics/Unemployed/Overview/CaseManagementCoaching/List.vue";
import PrivateLearningCoaching from "@/views/App/Analytics/Unemployed/Overview/PrivateLearningCoaching/List.vue";

import UnemployedList from "@/views/App/Analytics/Unemployed/DetailOverview/UnemployedList/List.vue";
import Overview from "@/views/App/Analytics/Unemployed/DetailOverview/Coaching/Overview.vue";
import CoachingDetails from "@/views/App/Analytics/Unemployed/DetailOverview/Coaching/CoachingDetails.vue";

const routesAnalyticsUnemployed = [

    // Overview
    {
        path: "unemployed/overview/private_coaching/list",
        name: "analyticsUnemployedPrivateCoachingList",
        component: PrivateCoaching,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "unemployed/overview/group_coaching/list",
        name: "analyticsUnemployedGroupCoachingList",
        component: GroupCoaching,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "unemployed/overview/socio_therapy_coaching/list",
        name: "analyticsUnemployedSocioTherapyCoachingList",
        component: SocioTherapyCoaching,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "unemployed/overview/assisted_living_coaching/list",
        name: "analyticsUnemployedAssistedLivingCoachingList",
        component: AssistedLivingCoaching,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "unemployed/overview/occupational_therapy_coaching/list",
        name: "analyticsUnemployedOccupationalTherapyCoachingList",
        component: OccupationalTherapyCoaching,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "unemployed/overview/job_coaching/list",
        name: "analyticsUnemployedJobCoachingList",
        component: JobCoaching,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "unemployed/overview/case_management_coaching/list",
        name: "analyticsUnemployedCaseManagementCoachingList",
        component: CaseManagementCoaching,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "unemployed/overview/private_learning_coaching/list",
        name: "analyticsUnemployedPrivateLearningCoachingList",
        component: PrivateLearningCoaching,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },


    // Details
    {
        path: "unemployed/details-overview/list",
        name: "analyticsUnemployedDetailsOverviewList",
        component: UnemployedList,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "unemployed/details-overview/:id",
        name: "analyticsUnemployedDetailsOverview",
        component: Overview,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },
    {
        path: "unemployed/details-overview/coaching-details/:coachingType/:id",
        name: "analyticsUnemployedDetailsOverviewCoachingDetails",
        component: CoachingDetails,
        meta: {
            roles: [
                UserRole.ADMIN,
                UserRole.SITE_SUPPORT,
                UserRole.SITE_MANAGER,
                UserRole.HEAD_OF_AMDL,
                UserRole.PRACTICE_MANAGER,
                UserRole.HEAD_OF_MARKETING,
                UserRole.ACCOUNTANT,
                UserRole.ASSISTANT_VQ,
                UserRole.PERSONAL,
                UserRole.HEAD_OF_HR,
            ]
        },
    },

]

export default routesAnalyticsUnemployed;